import { render, staticRenderFns } from "./industryActivistyCostAttribution.vue?vue&type=template&id=792c6001&scoped=true"
import script from "./industryActivistyCostAttribution.vue?vue&type=script&lang=js"
export * from "./industryActivistyCostAttribution.vue?vue&type=script&lang=js"
import style0 from "./industryActivistyCostAttribution.vue?vue&type=style&index=0&id=792c6001&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792c6001",
  null
  
)

export default component.exports